module.exports = __webpack_public_path__ + "img/versocall.3422147e.png";